import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { environment } from 'environments/environment';
import {
  CommonUtilty,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-view-profile-summary',
  templateUrl: './view-profile-summary.component.html',
  styleUrls: ['./view-profile-summary.component.scss']
})
export class ViewProfileSummaryComponent implements OnInit {

  _currentComponentName = 'ViewProfileSummaryComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler) { }

  //Declaraions which might need developer input
  viewProfileSummaryForm: FormGroup
  VIEWPROFILESUMMARYFORM = "viewProfileSummaryForm"
  selectorOfThisComponent = 'app-claims-basic-details'
  parentEvent$

  @Output() componentOutput = new EventEmitter<any>();
  @Input() clinetDO: any;
  @Input() transactionState: any;

  tempSelectedClient: any;
  configuredObject:any={}


  private _IO = null;
  @Input()
  set IO(value: any) {
    if (value) {
      this._IO = value;
      this.selectedClient = this.getClientDO(this._IO);
    }
  };

  selectedClient: any;
  get IO() {
    return this._IO;
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component

    } catch (error) {

    }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name

    } catch (error) {

    }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.EmitComponentOutput(null);
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }


  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    if (this.IO != null)
      this.initializeProfileSummaryForm(this.IO)
    this.subscribeToParentEvent()
    this.subscribeToInsuredListAndInitializeRibbon();
    this.setConfiguredClientDetails(this.selectedClient);
  }

  initializeProfileSummaryForm(data?) {
    let payload = data || {}
    this.viewProfileSummaryForm = this.fb.group({

    });
  }

  getClientDO(IO) {
    let output = null
    if (IO != null) {
      switch (this.transactionState) {
        case "client": {
          if (IO['intimationDO'] || IO['claimDO']) {
            this.clinetDO = IO['clientDOs'];
            let clientRoles: any = [];
            if (IO['intimationDO'])
              clientRoles = IO['intimationDO']['claimClientRoles']

            if (IO['claimDO'])
              clientRoles = IO['claimDO']['claimClientRoles'];

            if (IO['proposalDO'])
              clientRoles = IO['proposalDO']['proposalClients'];

            let insureClientRef = clientRoles.find(item => {
              if (item)
                return item['roleCd'] === 'INSURED';
            }) || []

            output = this.clinetDO.find(item => {
              if (item)
                return item['guid'] === insureClientRef.clientRefGuid;
            }) || []
            break;
          }
        }
        case "proposal_ManualUw": {
          if (IO['caseDO']) {
            let clientRoles: any = [];
            this.clinetDO = IO['clientDOs'];
            clientRoles = IO['caseDO']['caseClients']
            let insureClientRef = clientRoles.find(item => {
              if (item)
                return item['roleCd'] === 'INSURED';
            }) || []

            output = this.clinetDO.find(item => {
              if (item)
                return item['guid'] === insureClientRef.clientRefGuid;
            }) || []
            break;
          }
        }
        case "proposal_DataEntry": {
          if (IO['proposalDO']) {
            let clientRoles: any = [];
            this.clinetDO = IO['clientDOs'];
            clientRoles = IO['proposalDO']['proposalClients']
            let insureClientRef = clientRoles.find(item => {
              if (item)
                return item['roleCd'] === 'INSURED';
            }) || []

            output = this.clinetDO.find(item => {
              if (item)
                return item['guid'] === insureClientRef.clientRefGuid;
            }) || []
            break;
          }
        }
        default: {
          console.log("Invalid choice");
          break;
        }
      }
    }
    return output
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  

  subscribeToInsuredListAndInitializeRibbon() {
    this.interactService.insuredClientDOSubject$.subscribe(insured => {
      if (insured)
        this.selectedClient = insured;
    })
  }

  getLocalDateDurationTillDate(localDate, type) {
    let dateMoment = moment(localDate)
    if (localDate && dateMoment.isValid()) {
      let todayMoment = moment()
      let years = todayMoment.diff(dateMoment, 'year');
      dateMoment.add(years, 'years');
      let months = todayMoment.diff(dateMoment, 'months');
      dateMoment.add(months, 'months');
      let days = todayMoment.diff(dateMoment, 'days');
      if (years > -1 && months > -1 && days > -1) {
        if (type == 'object')
          // return { years: years, months: months, days: days }
          return { years: years }
        else if (type == 'string')
          // return (years + ' Years ' + months + ' Months ' + days + ' Days')
          return (years + ' Years ')
      }
      else {
        return null
      }
    }

  }



  setConfiguredClientDetails(client){
    if(client && client.personDO){
      this.configuredObject.fullName= (client.personDO.firstName || "" +  client.personDO.lastName || ""),
      this.configuredObject.genderCd =client.personDO.genderCd || "-",
      this.configuredObject.dateOfBirth =this.getDateString(client.personDO.dateOfBirth) || "-",
      this.configuredObject.countryOfBirthCd=  client.personDO.countryOfBirthCd || "-",
      this.configuredObject.age=this.getLocalDateDurationTillDate(client.personDO.dateOfBirth,'string') ,
      this.configuredObject.maritalStatusCd=client.personDO.maritalStatusCd || "-",
      this.configuredObject.externalClientNum=client.externalClientNum || "-",
      this.configuredObject.memberNum=client.memberNum || "-",
      this.configuredObject.loanNum=client.loanNum || "-",
      this.configuredObject.empNum=client.empNum || "-",
      this.configuredObject.memberStatus=client.memberStatus || "-",
      this.configuredObject.dependentNum=client.dependentNum || "-",
      this.configuredObject.memberAdditionDt=this.getLocalDateString(client.memberAdditionDt)
      this.configuredObject.personEmploymentList= this.commonUtilty.deepCopy(client.personDO.personEmploymentList)
      this.configuredObject.personIdentityList= this.commonUtilty.deepCopy(client.personDO.personIdentityList)
      this.configuredObject.personEducationList= this.commonUtilty.deepCopy(client.personDO.personEducationList)
      
    }
    
    
  }


  getLocalDateString(rawDate){
    
    let dateString
    let tempDate = this.commonUtilty.deepCopy(rawDate)
    tempDate = this.commonUtilty.serverDOtoUIDODate(tempDate);
    if (tempDate != null) {
      dateString = moment(tempDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = '-'
    }
    return dateString
  }

  /* Trail n error code */

  summarySectionsList = [
    {
      "titleWithIcon": "Ramesh Sable",
      "titleDesc": "Lookup",
      "icon": "anticon-contacts",
      "heading": null,
      "sectionType": "form",
      "sectionData": [
        {
          "label": "Insured Name",
          "key": "fullName",
          "pipe": null,
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },
        {
          "label": "Gender",
          "key": "genderCd",
          "pipe": "technicalTranslate",
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },
        {
          "label": "Date of Birth",
          "key": "dateOfBirth",
          "pipe": null,
          "showTag": false,
          "tagColor": "blue",
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },
        {
          "label": "Country Of Birth",
          "key": "countryOfBirthCd",
          "pipe": null,
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },
        {
          "label": "Age",
          "key": "age",
          "pipe": null,
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },
        {
          "label": "Marital Status",
          "key": "maritalStatusCd",
          "pipe": "technicalTranslate",
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },
        {
          "label": "Client Number",
          "key": "externalClientNum",
          "pipe": null,
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },
        {
          "label": "Member Number",
          "key": "memberNum",
          "pipe": null,
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },

        {
          "label": "Loan Number",
          "key": "loanNum",
          "pipe": null,
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },
        {
          "label": "Employee Number",
          "key": "empNum",
          "pipe": null,
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },

        {
          "label": "Member Status",
          "key": "memberStatus",
          "pipe": null,
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },

        {
          "label": "Dependent Number",
          "key": "dependentNum",
          "pipe": null,
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },

        {
          "label": "Member Addition Date",
          "value": "memberAdditionDt",
          "pipe": "",
          "showTag": false,
          "tagColor": null,
          "showBadge": false,
          "badgeStatus": null,
          "additionalValue": null
        },
      ],
    },
    {
      "titleWithIcon": false,
      "titleDesc": null,
      "icon": "select",
      "heading": "Occupation / Income",
      "sectionType": "grid",
      "showPagination":false,
      "sectionData": {
        "listAttribute": "personEmploymentList",
        "listHeader": [
          {
            "header": "Occupation",
            "key": "occupationCd",
            "isVisible": true,
            "pipe": "technicalTranslate"
          },
          {
            "header": "Annual Income",
            "key": "montlyIncome",
            "isVisible": true,
            "pipe": null
          }
        ]
      }
    }, 
    {
      "titleWithIcon": false,
      "titleDesc": null,
      "icon": "select",
      "heading": "KYC Details",
      "sectionType": "grid",
      "showPagination":false,
      "sectionData": {
        "listAttribute": "personIdentityList",
        "listHeader": [
          {
            "header": "Id",
            "key": "identityTypeCd",
            "isVisible": true,
            "pipe": "technicalTranslate"
          },
          {
            "header": "Available",
            "key": "yes",
            "isVisible": true,
            "pipe": null
          }, {
            "header": "Number",
            "key": "identityNum",
            "isVisible": true,
            "pipe": null
          }
        ]
      }
    },
    {
      "titleWithIcon": false,
      "titleDesc": null,
      "icon": "select",
      "heading": "Address",
      "sectionType": "custom-widget",
      "sectionId": "address"
    },
    {
      "titleWithIcon": false,
      "titleDesc": null,
      "icon": "select",
      "heading": "Education Details",
      "sectionType": "grid",
      "showPagination":false,
      "sectionData": {
        "listAttribute": "personEducationList",
        "listHeader": [
          {
            "header": "Course Name",
            "key": "courseCd",
            "isVisible": true,
            "pipe": "technicalTranslate"
          },
          {
            "header": "Education Type",
            "key": "educationTypeCd",
            "isVisible": true,
            "pipe": "technicalTranslate"
          }
        ]
      }
    }
  ];
}

